import T from "./JDictSelectTag.vue";
var JDictSelectTag = {
  install: function install(Vue) {
    Vue.component('JDictSelectTag', T);
  }
};
export default JDictSelectTag;